import axios from 'axios';
import { settings } from './../Helpers/Settings.js';
import { isExpired } from "react-jwt";

class AuthService {
    async login(mail, password) {
        const data = JSON.stringify({
            "mail": mail,
            "password": password,
            "encrypted": true
        });

        try {
            const response = await axios.post(settings.ApiUrl + "Login/Login", data, { headers: { 'Content-Type': 'application/json' }, withCredentials: true });

            if (response.status === 200) {
                if (response.data.success === true) {
                    localStorage.setItem("ATGroupToken", response.data.value.token);
                }
            }
        } catch (error) {
            console.log(error);
        }

        /*axios.post(settings.ApiUrl + "Login/Login",
            data, {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then((response) => {
            if (response.data.value.token) {
                localStorage.setItem('ATGroupToken', JSON.stringify(response.data.value.token));
                //axios.defaults.headers.common["Authorization"] = `Bearer ${response.data.value.token}`;
                //axios.defaults.headers.common["Authorization"] = response.data.value.token;
            }
            return response.data.value;
        });*/
    }

    logout() {
        //delete axios.defaults.headers.common["Authorization"];
        localStorage.removeItem('ATGroupToken');
        window.location = "/";
    }

    getCurrentUser() {
        try {
            return localStorage.getItem('ATGroupToken');
        } catch (error) {
            return "";
        }
    }

    isTokenExpired() {
        try {
            return isExpired(localStorage.getItem('ATGroupToken'));
        } catch (error) {
            return true;
        }
    }

    getHeaders() {
        return { 
            //"Access-Control-Allow-Headers" : "*",
            //"Access-Control-Allow-Origin" : "*",
            "Access-Control-Allow-Origin" : window.location.hostname === "localhost" ? "http://localhost:3000" : "https://" + window.location.hostname,
            "Authorization": "Bearer " + localStorage.getItem('ATGroupToken'),
            "Content-Type": "application/json"
        };
    }

    async getYetkiKontrolByYetki (yetki) {
        let result = false;

        if (isExpired(localStorage.getItem('ATGroupToken')) === false) {
            try {
                const res = await axios.get(settings.ApiUrl + "Rol/YetkiKontrolByYetki/" + yetki, { headers: this.getHeaders() });
    
                if (res.data) {
                    result = res.data.value;
                }
            } catch (error) {
                console.log(error);
                /*if (error.status === 401) {
                    window.location = '/';
                } else {
                    console.log(error);
                }*/
            }
    
            /*let result = false;
    
            await axios.get(settings.ApiUrl + "Rol/YetkiKontrolByYetki/" + yetki, { headers: this.getHeaders() })
                .then((response) => {
                    if (response.data) {
                        result = response.data;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
            
            return result;*/
        }

        return result;
    }
}

export default new AuthService();